"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = exports.Action = exports.defaultLanguages = void 0;
exports.reducer = reducer;
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const constructors_union_1 = require("@genesys/client-core/lib/constructors-union");
exports.defaultLanguages = ["en-GB", "en-US"];
exports.Action = (0, constructors_union_1.ctorsUnion)({
    RotorProductValidationSetSettings: (settings) => ({ settings }),
    RotorProductValidationSetValidationProgress: (inProgress, message, current, max) => ({ inProgress, message, current, max }),
    RotorProductValidationToggleFilter: () => ({}),
    RotorProductValidationHideFilter: () => ({}),
    RotorProductValidationSetResult: (messages) => ({
        messages
    })
});
exports.initialState = {
    loading: false,
    validationProgress: {
        inProgress: false,
        message: "",
        current: 0,
        max: 0
    },
    filterCollapsed: false,
    settings: {
        productId: undefined,
        errorsOnly: false
    },
    messages: []
};
// biome-ignore lint: -
function reducer(state = exports.initialState, action) {
    switch (action.type) {
        case "RotorProductValidationSetSettings": {
            return Object.assign(Object.assign({}, state), { settings: action.settings });
        }
        case "RotorProductValidationSetValidationProgress": {
            return Object.assign(Object.assign({}, state), { validationProgress: Object.assign(Object.assign({}, state.validationProgress), { inProgress: action.inProgress, message: action.message, current: action.current, max: action.max }) });
        }
        case "RotorProductValidationToggleFilter": {
            return Object.assign(Object.assign({}, state), { filterCollapsed: !state.filterCollapsed });
        }
        case "RotorProductValidationHideFilter": {
            return Object.assign(Object.assign({}, state), { filterCollapsed: true });
        }
        case "RotorProductValidationSetResult": {
            return Object.assign(Object.assign({}, state), { messages: action.messages });
        }
        default: {
            (0, ts_exhaustive_check_1.exhaustiveCheck)(action);
        }
    }
    return state;
}
//# sourceMappingURL=rotor-product-validation-state.js.map